import { get } from '../../Services/http';
import { catchError } from '../../Actions/Error.action';
import { NAVIGATION_LOAD_ERROR, NAVIGATION_RECEIVE } from '../../constants';

const firstHtml = document.querySelector('html');
const iso = firstHtml.getAttribute('lang');

export const load = () => (dispatch, getState) => {
    return get(`/api/navigation/${iso}`)
        .then((response) => response.json())
        .then((data) => dispatch(receive(data)))
        .catch((ex) => dispatch(catchError(ex, (error) => loadError(error))));
};

export const loadError = (error) => ({
    type: NAVIGATION_LOAD_ERROR,
    payload: {
        error,
    },
});

export const receive = (data) => ({
    type: NAVIGATION_RECEIVE,
    payload: {
        contentLinks: data,
    },
});
